import { createWebHistory, createRouter } from "vue-router";

import store from '@/state/store'
import routes from './routes'
import $cookies from "vue-cookies";
import $api from '@/state/api';

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach(async(routeTo, routeFrom, next) => {
  if (routeTo.path === '/login') {
    $api.resetSessionAlert();
  }
  
  const auth = store.getters["auth/authenticated"];
  const profile = store.getters["auth/profile"];

  // Fetch season colors if authenticated and not yet loaded
  if (auth && !store.state.seasonColors.active.year) {
    store.dispatch("seasonColors/fetchActive");
  }

	if (routeTo.matched.some((record) => record.meta.requiresAuth)) {
		if (!auth) {
			next("/login");
		} else {
      if (!profile.role && auth) {
        try {
          await store.dispatch("auth/getProfile");
        } catch (error) {
          console.warn("Failed to fetch profile:", error);
        }
      }
      
      const updatedProfile = store.getters["auth/profile"];
      if(updatedProfile.role != 'admin' && (routeTo.path == '/user' || routeTo.path == '/user/create'|| routeTo.path == '/activity-logs')){
        next("/")
      }else{
        next();
      }
		}
	} else if (routeTo.matched.some((record) => record.meta.requiresVisitor)) {
		if (auth) {
			next("/");
		} else {
			next();
		}
	} else {
		next();
	}
    $cookies.set("lastRoute", routeTo.fullPath)
})

export default router
